// 合作伙伴公司名称列表
export const partnerCompanies = [
  '迪柯尼',
  'BV家居',
  '安德玛',
  '芝华仕',
  'YARCH雅趋女装',
  '九牧王',
  '巴拉巴拉',
  '哈吉斯',
  'MM(麦檬)',
  'JAMSUN',
  '3COLOUR',
  '下半身',
  'MAXRIENY',
  '片断',
  '播女装',
  '千仞岗',
  'PH.KARIN',
  'TKNEGOZl0',
  'HAZZYS',
  '八百里▪秦味',
  '玩皮部落',
  'Y.SING',
  '飞鸟与新酒服饰',
  '亚瑟士',
  '八百里秦味',
  '斐乐',
  '凯乐石',
  '彪马',
  '谜底',
  'CHUU',
  '丝涟',
  '报喜鸟',
  'JAMSUN积上',
  'EIFINI（伊芙丽）',
  '耐克',
  '伊芙丽',
  'MSLAN',
  '基诺浦',
  'natursun娜冉',
  'POLOWALK',
  '播',
  '积上',
  'SEIFINI（诗凡黎）',
  'MIIDII',
  'TOTO卫浴',
  '乔丹',
  '纳图兹意迪森',
  '依文',
  '喜临门',
  '大宅系统家居',
  '大自然床垫',
  '方太厨电',
  'VICUTU',
  '九牧卫浴',
  '左右沙发',
  '千百度',
  '席梦思',
  '金利来',
  '秦潮味',
  '淘满鲜',
  '卓诗尼女鞋',
  '乔顿服饰',
  '粒上皇炒货',
  '凤时',
  '老板电器',
  'HARO地毯',
  '中铁',
  '乐盯女装',
  'AcupuNcTuRE',
  'AITU',
  '乐町女装',
  '乐町',
  '狮道芬堡男装',
  '久岁伴童装',
  'KSCO',
  '麦檬',
  '芙罗兰',
  '金利来男装',
  '芝华仕头等舱',
  '方太',
  '测试品牌',
  'Babycare',
  'LIGUEI',
  'Ann',
  'NeJustHuG',
  'MARYKKI',
  'Mmlg',
  'Aitoo.Suxi',
  'Beerbro',
  'CARECASE',
  '问童子',
];
